
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 4.281V3.188c0-.52.43-.938.964-.938h4.5l.378-.73c.16-.32.494-.52.86-.52h4.592c.366 0 .7.2.864.52l.378.73h4.5c.534 0 .964.418.964.938V4.28a.477.477 0 01-.482.469H2.482A.477.477 0 012 4.281zm16.682 2.215l-.82 12.746c-.064.988-.908 1.758-1.924 1.758H6.062c-1.016 0-1.86-.77-1.925-1.758l-.82-12.746A.475.475 0 013.8 6h14.404c.273 0 .494.227.478.496z","fill":"#636363","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_trash.svg